import React from "react";
import "../CSS/createProject.css";
const CreateProject = () => {
  return (
    <div>
      {/* Sidebar include replaced with a placeholder */}
      <div className="pp-sidebar-space"></div>

      <main className="pp-main-content">
        <div className="pp-dashboard-header">
          <h1 className="pp-header-title">
            <i className="fas fa-plus-circle"></i>
            Create New Project
          </h1>
          <div className="pp-login-status">
            <i className="fas fa-circle"></i>
            Active - Premium Member
          </div>
        </div>

        <div className="pp-project-form-container">
          <div className="pp-form-header">
            <h2>Project Information</h2>
            <p>
              Fill in all the details about your new film project to attract
              investors and collaborators
            </p>
          </div>

          <form id="projectForm" method="post" encType="multipart/form-data">
            <div className="pp-form-grid">
              <div className="pp-form-group">
                <label htmlFor="title">
                  Original Title <span>*</span>
                </label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  className="pp-form-control"
                  placeholder="Enter original title"
                  required
                />
              </div>

              <div className="pp-form-group">
                <label htmlFor="englishTitle">
                  English Title <span>*</span>
                </label>
                <input
                  type="text"
                  id="englishTitle"
                  name="englishTitle"
                  className="pp-form-control"
                  placeholder="Enter English title"
                  required
                />
              </div>
            </div>

            <div className="pp-form-grid">
              <div className="pp-form-group">
                <label htmlFor="type">
                  Type <span>*</span>
                </label>
                <div className="pp-select-wrapper">
                  <select id="type" name="type" className="pp-form-control" required>
                    <option value="">Select type</option>
                    <option value="Live Action">Live Action</option>
                    <option value="Animation">Animation</option>
                    <option value="Documentary">Documentary</option>
                    <option value="Hybrid">Hybrid</option>
                  </select>
                </div>
              </div>

              <div className="pp-form-group">
                <label htmlFor="stage">
                  Stage <span>*</span>
                </label>
                <div className="pp-select-wrapper">
                  <select id="stage" name="stage" className="pp-form-control" required>
                    <option value="">Select stage</option>
                    <option value="Script">Script</option>
                    <option value="Pre-Production">Pre-Production</option>
                    <option value="Production">Production</option>
                    <option value="Post-Production">Post-Production</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>
              </div>

              <div className="pp-form-group">
                <label htmlFor="format">
                  Format <span>*</span>
                </label>
                <div className="pp-select-wrapper">
                  <select id="format" name="format" className="pp-form-control" required>
                    <option value="">Select format</option>
                    <option value="Feature">Feature</option>
                    <option value="Short Film">Short Film</option>
                    <option value="TV Series">TV Series</option>
                    <option value="Web Series">Web Series</option>
                    <option value="Documentary">Documentary</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Continue converting rest of your JSP form fields... */}
            
            <div className="pp-form-actions">
              <button type="button" className="pp-btn pp-btn-secondary">
                <i className="fas fa-times"></i> Cancel
              </button>
              <button type="submit" className="pp-btn pp-btn-primary">
                <i className="fas fa-paper-plane"></i> Submit Project
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default CreateProject;
